import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || (isLocalHost ? 'http://localhost:5000' : window.location.origin);

const rewriteLocalhost5000Url = (url: string) => url.replace('http://localhost:5000', API_ORIGIN);

if (!isLocalHost) {
  const originalFetch = window.fetch.bind(window);
  window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
    if (typeof input === 'string') {
      return originalFetch(rewriteLocalhost5000Url(input), init);
    }
    if (input instanceof Request) {
      return originalFetch(new Request(rewriteLocalhost5000Url(input.url), input), init);
    }
    return originalFetch(String(input).startsWith('http://localhost:5000') ? rewriteLocalhost5000Url(String(input)) : input, init);
  }) as typeof window.fetch;

  const rewriteImageSources = (rootNode: ParentNode) => {
    const images = rootNode.querySelectorAll('img[src^="http://localhost:5000"]');
    images.forEach((img) => {
      img.setAttribute('src', rewriteLocalhost5000Url(img.getAttribute('src') || ''));
    });
  };

  document.addEventListener('DOMContentLoaded', () => rewriteImageSources(document));
  const observer = new MutationObserver(() => rewriteImageSources(document));
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
